import React, { useState, useEffect } from "react";
import { branch, fcover, flower, leaf2, mainLeaf } from "../../assets";
import astheticTreatments from "../../Data/astheticTreatments.json";
import TreatCard from "../../Components/treatmentCards/TreatCard";
import Pagination from "../../Components/UI/Pagination";
import { client } from "../../client";

const Sexology = ({ setSingleTreat }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [treatmentsPerPage, setTreatmentsPerPage] = useState(5);
  const [treatments, setTreatments] = useState([]);

  const lastPage = currentPage * treatmentsPerPage;
  const firstPage = lastPage - treatmentsPerPage;

  const currentTretments = treatments.slice(firstPage, lastPage);

  useEffect(() => {
    client.fetch('*[_type == "sexology"]').then((data) => setTreatments(data));
  }, []);

  return (
    <div className="sexology">
      <div className="gradient"></div>
      <div className="gradient2"></div>
      <img src={mainLeaf} alt="" className="mainLeaf" />
      <img src={leaf2} alt="" className="mainLeaf2" />
      <img src={flower} alt="" className="mainLeaf3" />
      <img src={flower} alt="" className="mainLeaf4" />
      <img src={branch} alt="" className="mainLeaf5" />

      <div className="page-title">
        <img src={fcover} alt="" />
        <div className="det">
          <h1>Our Sexology Treatments</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi,
            recusandae?
          </p>
        </div>
      </div>

      <div className="treatments">
        {currentTretments.map((data, i) => {
          return (
            <TreatCard key={i} data={data} setSingleTreat={setSingleTreat} />
          );
        })}
      </div>
      <div className="pagination">
        <Pagination
          total={treatments.length}
          perPage={treatmentsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default Sexology;
